import {Grid} from '@logistics-frontend/blocks'
import {Accordion, HeaderButton, LinkListMobile} from '@logistics-frontend/order-layout-blocks'
import clsx from 'clsx'
import React from 'react'

import {i18n} from 'src/shared/config'

import * as classes from './ServicesMenu.classes'

function ServicesMenu(): React.ReactElement {
  const buttonProps = {active: false, className: classes.linkListButtonDefault}

  return (
    <Grid alignItems="stretch" className={classes.root} direction="column" wrap="nowrap">
      <Accordion
        className={classes.root}
        data={[
          {
            header: i18n('order.header.link.delivery-to-buyer', 'Доставка до покупателя'),
            description: (
              <Grid className={classes.accordionsContainer} direction="column" wrap="nowrap">
                <Accordion
                  className={classes.inlineSpacing}
                  data={[
                    {
                      header: i18n('order.header.link.around-town', 'По городу'),
                      description: (
                        <LinkListMobile
                          className={clsx(classes.inlineSpacing, classes.linkListButtons)}
                          list={[
                            {
                              label: i18n('order.header.link.one-hour-delivery', 'Доставка за час'),
                              href: '/express-delivery/',
                              buttonProps,
                            },
                            {
                              label: i18n('order.header.link.next-day-delivery', 'Доставка на следующий день'),
                              href: '/next-day-delivery/',
                              buttonProps,
                            },
                            {
                              label: i18n('order.header.link.delivery-to-pvz', 'Доставка до ПВЗ'),
                              href: '/next-day-delivery/',
                              buttonProps,
                            },
                          ]}
                          separation={false}
                        />
                      ),
                    },
                  ]}
                />
                <Accordion
                  className={classes.inlineSpacing}
                  data={[
                    {
                      header: i18n('order.header.link.other-cities', 'В другие города'),
                      description: (
                        <LinkListMobile
                          className={clsx(classes.inlineSpacing, classes.linkListButtons)}
                          list={[
                            {
                              label: i18n('order.header.link.courier-delivery', 'Курьерская доставка'),
                              href: '/next-day-delivery/',
                              buttonProps,
                            },
                            {
                              label: i18n('order.header.link.delivery-to-pvs', 'Доставка до ПВЗ'),
                              href: '/next-day-delivery/',
                              buttonProps,
                            },
                          ]}
                          separation={false}
                        />
                      ),
                    },
                  ]}
                />
              </Grid>
            ),
          },
          {
            header: i18n('order.header.link.b2b-delivery', 'B2B-Доставка'),
            description: (
              <LinkListMobile
                className={clsx(classes.inlineSpacing, classes.linkListButtons)}
                list={[
                  {
                    label: i18n('order.header.link.courier-delivery', 'Курьерская доставка'),
                    href: '/next-day-delivery/',
                    buttonProps,
                  },
                  {
                    label: i18n('order.header.link.delivery-to-pvs', 'Доставка до ПВЗ'),
                    href: '/next-day-delivery/',
                    buttonProps,
                  },
                ]}
                separation={false}
              />
            ),
          },
        ]}
      />
      <Grid className={classes.accordionSeparationButton} item>
        <HeaderButton href="/business/restaurants/" variant="pseudo" active transparent>
          {i18n('order.header.link.restaurant-delivery', 'Доставка для ресторанов')}
        </HeaderButton>
      </Grid>
    </Grid>
  )
}

export default ServicesMenu
